import React, { useState } from 'react';
import {
    Box,
    Typography,
    TextField,
    Button,
    Paper,
    Grid,
    CircularProgress
} from '@mui/material';
import { toast } from 'react-toastify';
import { useUpdateMpinMutation } from '../store/services/userApi';

const MangeMpin = () => {
    const [oldMpin, setOldMpin] = useState('');
    const [newMpin, setNewMpin] = useState('');
    const [confirmMpin, setConfirmMpin] = useState('');

    const [updateMpin, { isLoading }] = useUpdateMpinMutation();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (newMpin !== confirmMpin) {
            toast.error("New MPIN and Confirm MPIN do not match");
            return;
        }

        try {
            const response = await updateMpin({
                old_mpin_pass: oldMpin,
                mpin_pass: newMpin
            }).unwrap();

            if (response.status) {
                toast.success(response.message || "MPIN updated successfully");
                setOldMpin('');
                setNewMpin('');
                setConfirmMpin('');
            }
        } catch (err) {
            console.error("MPIN Update Error:", err);
            toast.error(err?.data?.message || "Failed to update MPIN");
        }
    };
    const inputSx = {
        borderRadius: "0.5rem",
        minWidth: 140,
        "& .MuiOutlinedInput-root": {
            background: "rgba(255,255,255,0.7)",
            "& fieldset": { borderColor: "#E2E8F0" },
            "&:hover fieldset": { borderColor: "#94A3B8" },
        },
        "& .MuiInputLabel-root": { color: "#475569" },
        "& .Mui-disabled": {
            "& .MuiOutlinedInput-input": {
                color: "#334155 !important",
                WebkitTextFillColor: "#334155 !important",
            },
            "& .MuiOutlinedInput-notchedOutline": { borderColor: "#CBD5E1" },
        },
    };

    return (
        <Box sx={{ maxWidth: 400, mx: "auto", mt: 5, mb: 5 }}>
            <Paper elevation={3} sx={{ p: 3 }}>
                <Typography variant="h6" gutterBottom sx={{ fontSize: "0.9rem", fontWeight: 'bold' }}>
                    Manage MPIN
                </Typography>
                <form onSubmit={handleSubmit}>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <TextField
                                label="Old MPIN"
                                type="password"
                                fullWidth
                                value={oldMpin}
                                onChange={(e) => setOldMpin(e.target.value)}
                                required
                                size="small"
                                sx={inputSx}
                                slotProps={{ textField: { size: "small" } }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="New MPIN"
                                type="password"
                                fullWidth
                                value={newMpin}
                                onChange={(e) => setNewMpin(e.target.value)}
                                required
                                size="small"
                                sx={inputSx}
                                slotProps={{ textField: { size: "small" } }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <TextField
                                label="Confirm MPIN"
                                type="password"
                                fullWidth
                                value={confirmMpin}
                                onChange={(e) => setConfirmMpin(e.target.value)}
                                required
                                size="small"
                                sx={inputSx}
                                slotProps={{ textField: { size: "small" } }}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                fullWidth
                                disabled={isLoading}
                                sx={{
                                    fontSize: "0.7rem",
                                    textTransform: "none",
                                    bgcolor: isLoading ? "grey.400" : "#1976d2",
                                }}
                            >
                                {isLoading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </Paper>
        </Box>

    );
};

export default MangeMpin;
